import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpResponse,
  HttpErrorResponse,
} from "@angular/common/http";
import { MatDialog } from "@angular/material/dialog";
import { Observable, throwError } from "rxjs";
import { map, catchError, tap } from "rxjs/operators";
import { LoaderService } from "./loader.service";
import { CommonService } from "./common.service";
import { environment } from "src/environments/environment";
import { AlertService } from "./alert.service";
import { API_CONFIG } from "src/encryption/api.config";
import { Router } from "@angular/router";
import { INTERNAL_SERVER_ERROR, NO_INTERNET, STATIC_KEYS, UNAUTHORIZED } from "src/constants/constants";

@Injectable({
  providedIn: "root",
})
export class InterceptorService implements HttpInterceptor {
  constructor(
    private router: Router,
    private matDialog: MatDialog,
    private _loaderService: LoaderService,
    private _commonService: CommonService,
    private alertService: AlertService
  ) { }

  getCommonHeaders(req: HttpRequest<any>) {
    const token = this._commonService?.getItem(STATIC_KEYS.IDP_AUTH_TOKEN)?.replace(/"/g, "");
    let auth: any = {};

    if (token) {
      auth["Authorization"] = `Bearer ${token}`;
    }

    // @Note: Uncomment If needed
    if (!req.headers.has("x-api-key")) {
      auth["x-api-key"] = environment.x_api_key;
    }

    return auth;
  }

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isExcluded = API_CONFIG.excludeUrls.some((url) => req.url.includes(url));

    if (isExcluded) {
      return next.handle(req);
    }

    const authReq = req.clone({ setHeaders: this.getCommonHeaders(req) });

    return next.handle(authReq).pipe(
      tap((response: any) => {
        if (response instanceof HttpResponse) {

          const token = response?.body?.data?.token || (response && response.headers && (response.headers.get('X-Amzn-Remapped-Authorization') || response.headers.get('Authorization'))) || null;

          if (token) {
            this._commonService.setItem(STATIC_KEYS.IDP_AUTH_TOKEN, token);
          }

          if (response.body && (response.body?.header?.error || response.body.isError)) {
            this.alertService.showSnackBar(response.body.header.error.msg || response.body.message || "API Response Error");
            if (response.body.header.code == 401 || response.body.code == 401) this.logout();
          }
        }
      }),
      map((event: HttpEvent<any>) => {
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        this.errorState(error);
        return throwError(() => error.error ? error.error : error);
      })
    );
  }

  errorState(error: any) {
    if (error?.status == 401 || error?.body?.code == 401) {
      this.logout();
    } else if (error.status == 0) {
      if (!navigator.onLine) {
        this.alertService.showSnackBar(NO_INTERNET);
      }
    } else {
      this.alertService.showSnackBar(INTERNAL_SERVER_ERROR);
    }
  }

  logout() {
    this.alertService.showSnackBar(UNAUTHORIZED);
    this.matDialog.closeAll();
    this._commonService.removeItem(STATIC_KEYS.IDP_AUTH_TOKEN);
    this._commonService.removeItem(STATIC_KEYS.PERMISSIONS);
    this.router.navigateByUrl("/");
  }
}
